import { render, staticRenderFns } from "./homeTrim.vue?vue&type=template&id=8d9a1b24&scoped=true"
import script from "./homeTrim.vue?vue&type=script&lang=js"
export * from "./homeTrim.vue?vue&type=script&lang=js"
import style0 from "./homeTrim.vue?vue&type=style&index=0&id=8d9a1b24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9a1b24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d9a1b24')) {
      api.createRecord('8d9a1b24', component.options)
    } else {
      api.reload('8d9a1b24', component.options)
    }
    module.hot.accept("./homeTrim.vue?vue&type=template&id=8d9a1b24&scoped=true", function () {
      api.rerender('8d9a1b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/creatApp/components/homeTrim.vue"
export default component.exports